import { hasNegativeTabIndex } from './has-negative-tabindex';
import { isFocusable } from './is-focusable';

/**
 * Determines whether the given element is focusable and has non-negative tab index
 */
export function isTabbable(element: Element): boolean {
  return (
    element instanceof HTMLElement &&
    isFocusable(element) &&
    !hasNegativeTabIndex(element)
  );
}
